import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment-timezone';
import { localize } from '../../i18n';


const DeliveryTime = function DeliveryTime(props) {
  const {
    epochs,
    affiliateTimeZone,
    className,
    expanded,
  } = props;

  let deliveryStart = '';
  let deliveryEnd = '';
  let deliveryDate = null;
  let deliveryRangeStart = null;
  let deliveryRangeEnd = null;
  deliveryStart = _.find(epochs, { name: 'service_window_start' });
  deliveryEnd = _.find(epochs, { name: 'service_window_end' });

  if (deliveryStart && deliveryEnd) {
    let affiliateTZ = moment.tz.guess();
    if (affiliateTimeZone.length > 0) {
      affiliateTZ = affiliateTimeZone;
    }
    deliveryDate = (
      <span className="uk-text-danger">
        {moment(deliveryStart.value).tz(affiliateTZ).format('MM/DD/YYYY')}
      </span>
    );
    deliveryRangeStart = (
      <span className="uk-text-danger">
        {moment(deliveryStart.value).tz(affiliateTZ).format('hh:mm A')}
      </span>
    );
    deliveryRangeEnd = (
      <span className="uk-text-danger">
        {moment(deliveryEnd.value).tz(affiliateTZ).format('hh:mm A')}
      </span>
    );
    if (expanded) {
      return (
        <div className={`${className} delivery-time`}>{props.t('Due between {deliveryRangeStart} - {deliveryRangeEnd} on {deliveryDate}', { deliveryRangeStart, deliveryRangeEnd, deliveryDate })}</div>
      );
    }
    return (
      <div className={`${className} delivery-time`}>{moment(deliveryStart.value).format('DD-MMM   hh:mm A')} - {moment(deliveryEnd.value).format('hh:mm A')}</div>
    );
  }

  return null;
};

DeliveryTime.propTypes = {
  className: PropTypes.string,
  epochs: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.number,
  })),
  affiliateTimeZone: PropTypes.string,
  expanded: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

DeliveryTime.defaultProps = {
  className: '',
  expanded: false,
  affiliateTimeZone: '',
};


const mapStateToProps = (state) => {
  let affiliateTimeZone;
  if (state.affiliates && state.affiliates.selectedAffiliateInfo !== null) {
    affiliateTimeZone = state.affiliates.selectedAffiliateInfo.attributes.timezone;
  }
  return {
    affiliateTimeZone,
  };
};

export default localize(connect(mapStateToProps)(DeliveryTime));



// WEBPACK FOOTER //
// ./src/components/Filters/DeliveryTime.js